exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prices .price {\n  text-align: start;\n}\n.prices .price > div {\n    -ms-flex-direction: column-reverse;\n        flex-direction: column-reverse;\n    color: #333333;\n}\n.prices .price .price-special {\n    color: #11bb2e !important;\n}\n.prices .cl-mine-shaft, .prices .price-original {\n  font-size: 14px;\n  text-align: start;\n  font-family: 'TTNorms Bold', sans-serif;\n}\n", ""]);

// exports
